export default "__VITE_ASSET__8194dad1__"